<template>
  <section>
    <b-field
      v-for="(item, index) in data" :key="index"
      style="
        margin-bottom: 5px;
        margin-top: 20px;
        flex-direction: column;
        flex-wrap: wrap;
      "
    >
      <b-field v-for="(itemField, index) in item" :key="index" style="margin-right: 5px; margin-left: 5px; margin-top: 5px;">
        {{index}}
        <b-input v-model="itemField.data" expanded></b-input>
      </b-field>
      <div style="align-self: flex-end;">
        <button
          type="button"
          class="button is-primary"
          style="
            margin-top: 10px;
            margin-right: 5px;
            align-self: flex-end;
          "
          @click="remove(index)"
        >
          Remove
        </button>
      </div>
    </b-field>
    <b-field>
      <button type="button" class="button is-primary" @click="add" style="margin-top: 15px;">
        <b-icon icon="plus" size="is-small"></b-icon>
        <span>Add</span>
      </button>
    </b-field>
  </section>
</template>

<script>
  export default {
    name: 'c-multi-array-input',
    props: ['value'],
    data() {
      return {
        data: this.value.data || this.value,
      }
    },
    methods: {
      add() {
        this.data.push({
          host: {
            data: '',
          },
          port: {
            data: '',
          },
          dbname: {
            data: '',
          },
          user: {
            data: '',
          },
          password: {
            data: '',
          },
        })
      },
      remove(index) {
        this.data.splice(index, 1)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/lib/components/MultiArrayInput.vue